import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import { animationTransition } from '@utils/animationTransition';
import { styled } from '@styledComponents';
import { CTALink } from '@components/CTALink';
import { Columns } from '@components/Columns';
import { variant } from 'styled-system';
import { Text } from '@components/typography';

export const FooterHeroMenuItem = styled.div`
  // This is not a joykit typography so leaving it here
  a {
    font-family: Austin News Headline Web;
    font-style: normal;
    font-weight: 300;
    font-size: 48px;
    line-height: 64px;
    letter-spacing: -0.015em;
    white-space: nowrap;
    @media screen and (min-width: ${props => props.theme.breakpoints[1]}) {
      font-size: 72px;
      line-height: 93px;
    }
    ${themeMediaQuery('below_sm')} {
      font-size: 36px;
      line-height: 64px;
    }
  }
`;

export const FooterSubHeroHeader = styled.div.attrs({ typography: 'sectionEyeBrow24' })`
  ${variant({
    prop: 'typography',
    scale: 'typography',
  })};
  margin-bottom: 14px;

  color: ${themeColor('linkFooterDefault')};
`;

export const FooterSubHeroItem = styled.div`
  ${CTALink} {
    line-height: 19px;
    font-size: 20px !important;
    font-style: normal;
  }
  margin-bottom: ${themeSpace(6)};

  ${themeMediaQuery('below_sm')} {
    ${CTALink} {
      line-height: 36px;
    }
  }
`;

export const FooterSubHeroItemText = styled(Text)`
  font-size: 24px;
  line-height: 35px;
`;

export const FooterSubHeroItems = styled.div`
  ${CTALink} {
    font-size: 20px;
    line-height: 19px;
    font-weight: 400;
    color: #cdb4ff;
    font-family: AkkuratLLSub-RegularSubset, sans-serif;
  }
  margin-bottom: ${themeSpace(6)};

  ${themeMediaQuery('below_sm')} {
    ${CTALink} {
      line-height: 18px;
    }
  }
`;

export const SocialMediaMenuList = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 12px;
  svg {
    :hover {
      color: ${themeColor('purple3')};
    }
    transition: ${animationTransition('color')};
  }
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const FooterColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const FooterColumn = styled(Columns.Column)`
  width: 50%;
  text-align: left;
  ${themeMediaQuery('below_sm')} {
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
  }
`;

export const CTALinkHash = styled(CTALink)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const CTALinkHashMobile = styled(CTALink)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    margin: auto;
    margin-top: ${themeSpace(7)};
  }
`;

export const BottomMenuList = styled.div`
  display: inline-flex;
  flex-direction: row;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: ${themeSpace(9)};
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const BottomMenuListMobile = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const BottomCTALink = styled(CTALink)<{ noreferrer?: boolean; noopener?: boolean }>`
  margin: 0 ${themeSpace(3)};
  color: #9069dd;
  ${themeVariant('dek15')};
  ${themeMediaQuery('below_sm')} {
    margin: 0 0 ${themeSpace(5)};
    ${themeVariant('caption')};
  }
`;

export const BottomPrivacyCTALink = styled(CTALink)`
  margin: 0 ${themeSpace(1)};
  color: #9069dd;
  ${themeVariant('dek15')};
  ${themeMediaQuery('below_sm')} {
    margin: 0 0 ${themeSpace(5)};
    ${themeVariant('caption')};
  }
`;

export const BottomText = styled(Text)`
  color: #9069dd;
  ${themeVariant('dek15')};
  ${themeMediaQuery('below_sm')} {
    margin: 0 ${themeSpace(1)} ${themeSpace(5)};
    ${themeVariant('caption')};
  }
`;
